import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Theme, THEMES } from '@demeter/lib/models';

import { PresentationModeService } from '../presentation-mode.service';
import { SettingsDrawerService } from '../settings-drawer.service';
import { UserSettingsService } from '../user-settings.service';

@Component({
	selector: 'df-settings-drawer',
	imports: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './settings-drawer.component.html',
	styleUrl: './settings-drawer.component.scss'
})
export class SettingsDrawerComponent {
	readonly drawer = inject(SettingsDrawerService);
	readonly userSettings = inject(UserSettingsService);
	readonly presentation = inject(PresentationModeService);
	private readonly router = inject(Router);

	readonly themeOptions: { value: Theme; icon: string; label: string }[] = [
		{ value: 'light', icon: 'bi-sun', label: 'Light' },
		{ value: 'dark', icon: 'bi-moon-stars', label: 'Dark' },
		{ value: 'system', icon: 'bi-circle-half', label: 'System' }
	];

	get disabled(): boolean {
		return this.userSettings.state() === 'unavailable';
	}

	setTheme(theme: Theme): void {
		if (!this.disabled && THEMES.includes(theme)) this.userSettings.save({ theme });
	}

	togglePresentation(checked: boolean): void {
		if (!this.disabled) this.userSettings.save({ presentationMode: checked });
	}

	manageFlags(): void {
		this.drawer.closeDrawer();
		this.router.navigateByUrl('/tools/config/funds');
	}
}
